"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_SENSITIVITY_LABELS = exports.DATA_SENSITIVITY_COLORS = void 0;
const _types_1 = require("../@types/index.js");
exports.DATA_SENSITIVITY_COLORS = {
    [_types_1.DataSensitivityLevelId.None]: '',
    [_types_1.DataSensitivityLevelId.Public]: 'green',
    [_types_1.DataSensitivityLevelId.Internal]: 'gold',
    [_types_1.DataSensitivityLevelId.Confidential]: 'volcano',
    [_types_1.DataSensitivityLevelId.Restricted]: 'red',
    [_types_1.DataSensitivityLevelId.MissionCritical]: 'magenta'
};
exports.DATA_SENSITIVITY_LABELS = {
    [_types_1.DataSensitivityLevelId.None]: 'No Data Sensitivity Level',
    [_types_1.DataSensitivityLevelId.Public]: 'Public',
    [_types_1.DataSensitivityLevelId.Internal]: 'Internal',
    [_types_1.DataSensitivityLevelId.Confidential]: 'Confidential',
    [_types_1.DataSensitivityLevelId.Restricted]: 'Restricted',
    [_types_1.DataSensitivityLevelId.MissionCritical]: 'Mission Critical'
};
//# sourceMappingURL=DATA_SENSITIVITY.js.map